const constants = {
  noData: 'font-nunitoMedium text-sm tracking-[0.1px] text-center text-fontBlock w-full bg-white m-0'
};

export default constants;
